import { useEffect, useState } from 'react';
import { setupStatusSchema, type SetupStatus } from '@sqi/shared-schemas';
import { request } from '../../lib/oem-client';
import type { OemContext } from '../../lib/auth';
export function GuidedSetup({
  context,
  link,
}: {
  context: OemContext;
  link: (page: string) => string;
}) {
  const [data, setData] = useState<SetupStatus | null>(null);
  const [error, setError] = useState(false);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    let active = true;
    void request(`/setup/${context.projectId}`)
      .then((raw) => {
        const parsed = setupStatusSchema.safeParse(raw);
        if (active) {
          if (parsed.success) {
            setData(parsed.data);
            setError(false);
          } else setError(true);
        }
      })
      .catch(() => {
        if (active) setError(true);
      });
    return () => {
      active = false;
    };
  }, [context.projectId, reload]);
  return (
    <section className="card" aria-label="เริ่มใช้งานจากข้อมูลที่บันทึก">
      <h2>เริ่มใช้งานทีละขั้น</h2>
      <p>อ่านจากข้อมูลที่บันทึกตามสิทธิ์ปัจจุบัน · ไม่ใช่การอนุมัติผลิต</p>
      <button className="action secondary" onClick={() => setReload((n) => n + 1)}>
        ตรวจสถานะอีกครั้ง
      </button>
      {error ? (
        <p role="status">ยังตรวจข้อมูลที่บันทึกไม่ได้ โปรดลองอีกครั้งเมื่อออนไลน์</p>
      ) : data?.projectId !== context.projectId ? (
        <p role="status">กำลังตรวจข้อมูลที่บันทึก</p>
      ) : (
        <>
          <ol>
            {data.steps.map((step) => (
              <li key={step.key}>
                {step.page ? <a href={link(step.page)}>{step.label}</a> : <span>{step.label}</span>}
                <p>
                  {step.state === 'done'
                    ? 'มีข้อมูลแล้ว'
                    : step.state === 'next'
                      ? 'ทำขั้นนี้ต่อได้'
                      : 'รอข้อมูลหรือผู้มีสิทธิ์'}{' '}
                  · {step.detail}
                </p>
              </li>
            ))}
          </ol>
          {data.provider ? (
            <>
              <h3>ผู้ช่วยอ่านภาพ ค้นอ้างอิง และเสนอสูตร</h3>
              <p>
                {data.provider.model} ·{' '}
                {data.provider.status === 'blocked'
                  ? 'ยังไม่เปิดใช้งาน'
                  : 'ยังไม่ผ่านการทดสอบบริการจริง'}
              </p>
              <p>
                ใช้การอ่านและกรอกข้อมูลด้วยตนเองได้ ข้อเสนอ AI ต้องทบทวนและไม่ยืนยันการทดสอบ
                ความปลอดภัย หรือกฎหมาย
              </p>
            </>
          ) : null}
          {data.monitor ? (
            <p>
              ติดตามแหล่งข้อมูล {data.monitor.configuredSources} แหล่ง ·{' '}
              {data.monitor.persistence === 'unconfigured'
                ? 'ยังไม่มีที่เก็บ digest ถาวร จึงยังไม่ยืนยันการเปลี่ยนแปลง'
                : 'ตั้งค่าที่เก็บแล้ว'}{' '}
              · ยังไม่ยืนยันบริการจริง
            </p>
          ) : null}
        </>
      )}
    </section>
  );
}
